export const SERVICE_CODE = 'CONTRACTOR' + '_SERVICE';
